import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { seoArticles } from '@/mocks/seoArticles';
import { SITE_URL } from '@/constants';

export default function GuidaShopping() {
  const hubSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Guida Shopping Itaobuy Spreadsheet 2026 — Tutti gli Articoli SEO',
    description: 'Raccolta completa di guide e articoli SEO su Itaobuy Spreadsheet: sicurezza, sneakers, recensioni, confronti e molto altro per lo shopping online in Italia nel 2026.',
    url: `${SITE_URL}/guida-shopping`,
    inLanguage: 'it',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: 'Guida Shopping Itaobuy Spreadsheet 2026', item: `${SITE_URL}/guida-shopping` },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(hubSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      <main className="pt-24">
        <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
          <div className="max-w-[1400px] mx-auto text-center mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              Guida Shopping 2026
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              Tutte le Guide{' '}
              <span className="text-primary-600">Itaobuy Spreadsheet</span>
            </h1>
            <p className="text-foreground-500 max-w-[650px] mx-auto">
              Esplora la nostra raccolta completa di articoli SEO per scoprire tutto su Itaobuy Spreadsheet:
              sicurezza, prodotti, recensioni, confronti e strategie per lo shopping online in Italia.
            </p>
          </div>

          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {seoArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/articolo/${article.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.h1}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={article.h1}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                    <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-700 whitespace-nowrap">
                      {article.date}
                    </span>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.h1}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-600 whitespace-nowrap">
                      Leggi l'articolo
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-12">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap"
              >
                Torna alla Home
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-home-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}